/* istanbul ignore file */

import { css } from 'styled-components';
export var hideScrollbar = /*#__PURE__*/css(["", " -ms-overflow-style:none;", " scrollbar-width:none;overflow-y:scroll;&::-webkit-scrollbar{", " display:none;}"], /* for Internet Explorer, Edge */'', /* for Firefox */'', /* for Chrome, Safari, and Opera */'');